module.exports = __webpack_public_path__ + "static/media/patrol(1).1ac58e40.PNG";